// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitStandaloneHotelLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/SearchUnitStandaloneHotelLayout/SearchUnitStandaloneHotelLayout.scss
 ** module id = 963
 ** module chunks = 1
 **/